import { useLocale } from '../../application/i18n/LocaleProvider';
import { useGarden } from '../../application/plants/useGarden';
import { useAppOffers } from '../../application/pwa/useAppOffers';
import InstallOfferCard from './InstallOfferCard';
import NotificationOfferCard from './NotificationOfferCard';

/**
 * The one place in the app that may ask the visitor for anything (SPEC-016).
 *
 * At most one card, at the foot of the page, on the tabbed screens only — never
 * on the landing, which is a marketing front door with its own single call to
 * action, and never on a plant detail page, which is immersive and has one
 * action pinned to its foot already.
 *
 * Which card, and whether either, is `useAppOffers`. This component only draws
 * the answer, which is why it has no state of its own.
 */
export default function AppOffers() {
    const { localeCode, languageCode } = useLocale();
    const { plantIds } = useGarden();
    const {
        offer,
        installActionKey,
        installHowToKey,
        acceptInstall,
        dismissInstall,
        enableNotifications,
        dismissNotifications,
    } = useAppOffers({ savedPlantCount: plantIds.length, localeCode, languageCode });

    if (offer === 'install') {
        return (
            <InstallOfferCard
                actionKey={installActionKey}
                howToKey={installHowToKey}
                onInstall={acceptInstall}
                onDismiss={dismissInstall}
            />
        );
    }

    if (offer === 'notify') {
        return (
            <NotificationOfferCard
                onEnable={enableNotifications}
                onDismiss={dismissNotifications}
            />
        );
    }

    return null;
}
